import { variantPrefix } from '../../../../../variant'

import registrationFields from './fields/registration'
import reportFields from './fields/report'

export const ORIGIN_IDENTIFIER = `${variantPrefix}reporta`

export const REGISTRATION_FIELDS = {
  ...registrationFields,
  ...reportFields,
}

export function getCurrentStep(registrationData) {
  if (
    (registrationData.recording_id || registrationData.skip_recording) &&
    !registrationData.allow_update
  ) {
    return 4
  }

  if (registrationData.document_id) {
    return 3
  }

  if (Object.values(reportFields)[0].parseRegistration(registrationData)) {
    return 2
  }

  if (
    Object.values(registrationFields)[0].parseRegistration(registrationData)
  ) {
    return 1
  }

  return 0
}

export function formHelperText(fieldId, formErrors = {}) {
  if (formErrors[fieldId]) {
    switch (formErrors[fieldId]) {
      case 'invalid_registration':
        return 'Não encontramos esse e-mail na base da Recode. Digite seu e-mail cadastrado lá.'
      case 'tooRecent':
        switch (fieldId) {
          case 'applicant_age_group':
          case 'applicant_a_age_group':
          case 'applicant_b_age_group':
          case 'applicant_c_age_group':
          case 'applicant_d_age_group':
          case 'applicant_e_age_group':
          case 'applicant_f_age_group':
          case 'applicant_born_at':
            return 'Inscrições apenas acima de 18 anos'
          default:
            return 'Data inválida'
        }
      case 'blank':
        switch (fieldId) {
          case 'accepts_terms_of_use':
            return 'Você deve estar de acordo para poder prosseguir'
          case 'accepts_pitch_showcase':
            return 'Você deve estar de acordo com o item acima para poder prosseguir'
          default:
            return 'Preenchimento obrigatório'
        }
      case 'taken':
        switch (fieldId) {
          case 'applicant_email':
            return 'Este e-mail já está registrado para outra inscrição.'
          default:
            return 'Já está registrado para outra inscrição'
        }
      case 'invalid_url':
        return 'Informe uma URL válida'
      case 'invalid_leader':
        return 'Informe o e-mail do líder da equipe'
      case 'invalid':
        switch (fieldId) {
          case 'applicant_email':
          case 'applicant_b_email':
          case 'applicant_c_email':
          case 'applicant_d_email':
          case 'applicant_e_email':
          case 'applicant_f_email':
            return 'Informe um endereço de e-mail válido'
          case 'applicant_github_url':
          case 'applicant_linkedin_url':
          case 'applicant_curriculum_url':
          case 'applicant_b_curriculum_url':
          case 'applicant_c_curriculum_url':
          case 'applicant_d_curriculum_url':
          case 'applicant_e_curriculum_url':
          case 'applicant_f_curriculum_url':
          case 'report_dataroom':
          case 'report_product_map':
          case 'report_product_mockup':
          case 'team_github':
          case 'team_google_drive':
            return 'Informe uma URL válida'
          case 'applicant_born_at':
            return 'Informe uma data de nascimento válida'
          case 'applicant_phone':
            return 'Informe um número de celular válido'
          case 'applicant_proposal_registry':
            return 'Informe um CNPJ válido'
          case 'applicant_proposal_resource_distribution':
            return 'O valor total da distribuição deverá ser igual à 100%'
          default:
            return formErrors[fieldId]
        }
      default:
        return formErrors[fieldId]
    }
  }

  if (REGISTRATION_FIELDS[fieldId].helperText) {
    return REGISTRATION_FIELDS[fieldId].helperText
  }

  return null
}

export function formLabel(fieldId, formData) {
  if (typeof REGISTRATION_FIELDS[fieldId].label === 'function') {
    return REGISTRATION_FIELDS[fieldId].label(fieldId, formData)
  }

  return REGISTRATION_FIELDS[fieldId].label
}

export function formOptions(fieldId, formData) {
  if (typeof REGISTRATION_FIELDS[fieldId].options === 'function') {
    return REGISTRATION_FIELDS[fieldId].options(fieldId, formData)
  }

  return REGISTRATION_FIELDS[fieldId].options
}
